export default __webpack_public_path__ + "static/spanish_sahara-d5937f431996a4700b28c3d232481f00.png";